import React, { useEffect, useState } from "react";
import { AppListing } from "../../components/appListing";
import {
  useGetPaymentKeysMutation,
  useGetUserInfoQuery,
  usePatientAdvancePaymentQuery,
} from "../../redux/service/billing_services";
import OnlinePaymentDialog from "./OnlinePaymentDialog";
import { getUser } from "../../userStore";
import DropDown from "../../components/DropDown";
import { HiDotsVertical } from "react-icons/hi";
import MainPageDialog from "../../components/mainPageDialog";
import LoadingBar from "../../components/LoadingBar";
import { formattedDatePp, getBaseUrl } from "../../utils/common_lib";

function Billing() {
  const user = getUser();
  const { data: userDetailData } = useGetUserInfoQuery();
  const [previewData, setPreviewData] = useState(null);
  const [onlinePaymentDialog, setOnlinePaymentDialog] = useState(false);
  const [paymentKeys, setPaymentKeys] = useState();
  const [getPaymentKeys] = useGetPaymentKeysMutation();
  const [loading, setLoading] = useState(false);
  const { data, isLoading, refetch } = usePatientAdvancePaymentQuery();
  const cols = [
    {
      title: "Patient Name",
      getData: (data) => {
        return data?.full_name;
      },
    },
    {
      title: "Amount",
      key: "status",
      getData: (data) => {
        return "$ " + data?.amount_paid_debit;
      },
    },
    {
      title: "Balance",
      getData: (data) => {
        return "$ " + data?.balance;
      },
    },
    { title: "Payment Date", key: "payment_method" },
    { title: "Encounter / Appointment Date ", key: "processed_by_name" , getData: (data) => {
      return formattedDatePp(data?.appointment_date,"MM/DD/YYYY, h:mm A")
    },},

    {
      title: "DOS",
    },

    {
      title: "Action",
      getData: (item,itemIndex) => {
        return (
          <DropDown
            optionIcon={<HiDotsVertical className="h-5 w-5" />}
            position={data?.data?.length-1==itemIndex?"up":"bottom"}
            customStyle="items-center text-black bg-transparent shadow-inherit"
            menuList={[
              {
                label: "Print Invoice",
                onClick: () => {
                  setPreviewData(item);
                },
              },
            ]}
          />
        );
      },
    },
  ];
  useEffect(() => {
    setLoading(true);
    getPaymentKeys().then((res) => {
      setLoading(false);
      setPaymentKeys(res?.data);
    });
  }, []);
  let fileUrl = `${
    getBaseUrl()
  }/messages/read_attachment.json?uuid=${
    previewData && previewData.invoice_hash
  }&token=${user?.token}&tz=${new Date().getTimezoneOffset()}`;
  let html = `<iframe id="printDiv" width="100%" height="1100" scrolling="auto" frameborder="1" allow="autoplay" src=${fileUrl}></iframe>`;
  return (
    <div className="text-left">
      {previewData && (
        <MainPageDialog
          title={"Print Invoice"}
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              type: "close",
              title: "Close",
              action: () => setPreviewData(null),
            },
          ]}
          onCancelHandler={() => setPreviewData(null)}
        >
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
        </MainPageDialog>
      )}
      {onlinePaymentDialog && (
        <OnlinePaymentDialog
          setPreviewData={setPreviewData}
          paymentKeys={paymentKeys}
          onlinePaymentDialog={onlinePaymentDialog}
          setOnlinePaymentDialog={setOnlinePaymentDialog}
        />
      )}{" "}
      <div className="p-3 bg-gray-100 text-xl font-semibold">Billing</div>
      <div className="grid grid-cols-2 p-5 gap-3 border-b">
        <div className="font-semibold">
          Unapplied:
          <span className="pl-2 font-light">
            {"$" + (userDetailData?.demographic?.Unapplied || "00.0")}
          </span>
        </div>
        <div className="font-semibold">
          Patient:
          <span className="pl-2 font-light">
            {"$" + (userDetailData?.demographic?.patient_balance || "00.0")}
          </span>
        </div>
        <div className="font-semibold">
          Plan:
          <span className="pl-2 font-light">
            {"$" + (userDetailData?.demographic?.plan_balance || "00.0")}
          </span>
        </div>
        <div className="font-semibold">
          Credit:
          <span className="pl-2 font-light">
            {"$" + (userDetailData?.demographic?.Unapplied || "00.0")}
          </span>
        </div>
      </div>
      {loading && (
        <div className="mb-3 -mx-4">
          <LoadingBar />
        </div>
      )}
      <div className="py-2 m-3">
        <div className="flex justify-between items-center mb-4">
          <div className="text-sky-700 font-semibold ">Advanced</div>
          <div className="flex items-center">
            {paymentKeys?.omni_api_key && paymentKeys?.omni_web_token && (
              <div
                className="text-sm bg-sky-600 text-white px-4 py-1.5 cursor-pointer"
                onClick={() => setOnlinePaymentDialog(true)}
              >
                Pay Now{" "}
              </div>
            )}

            <div>
              <button
                onClick={async () => {
                  setLoading(true);
                  await refetch();
                  setLoading(false);
                }}
                className="rounded bg-white px-2 h-8 ml-2 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <AppListing loading={isLoading} listData={data?.data} cols={cols} />
      </div>
    </div>
  );
}

export default Billing;
